<app-alert-modal *ngIf="modalState.isOpen && modalState.config"
                 [title]="modalState.config.title"
                 [message]="modalState.config.message"
                 [messageClasses]="modalState.config.messageClasses || ''"
                 [yesButtonText]="modalState.config.yesButtonText || 'Oui'"
                 [noButtonText]="modalState.config.noButtonText || 'Non'"
                 (result)="onModalResult($event)"></app-alert-modal>
